import { cssProps } from '@oracle/oraclejet-cssprops';
import keys from 'ramda/src/keys';

const directionStyles = {
  row: cssProps`${{
    flexDirection: 'row'
  }}`,

  column: cssProps`${{
    flexDirection: 'column'
  }}`
};

const wrapStyles = {
  nowrap: cssProps`${{
    flexWrap: 'nowrap'
  }}`,

  wrap: cssProps`${{
    flexWrap: 'wrap'
  }}`,

  reverse: cssProps`${{
    flexWrap: 'wrap-reverse'
  }}`,

  inherit: cssProps`${{
    flexWrap: 'inherit'
  }}`,

  initial: cssProps`${{
    flexWrap: 'initial'
  }}`
};

const flexboxStyles = {
  direction: directionStyles,
  wrap: wrapStyles
};

const directions = keys(directionStyles);
const wraps = keys(wrapStyles);

// See https://stackoverflow.com/questions/55377365/what-does-keyof-typeof-mean-in-typescript
// typeof operator gives you the type of an object
// then keyof operator gives you the literal type union
// derive the types of each property from the implementation
export type FlexboxProps = {
  direction?: keyof typeof directionStyles; // e.g, type is "column"|"row"|undefined
  wrap?: keyof typeof wrapStyles;
};

const flexboxInterpolations = {
  direction: ({ direction }: Pick<FlexboxProps, 'direction'>) =>
    direction === undefined
      ? {}
      : {
          class: directionStyles[direction]
        },
  wrap: ({ wrap }: Pick<FlexboxProps, 'wrap'>) =>
    wrap === undefined
      ? {}
      : {
          class: wrapStyles[wrap]
        }
};

export { directions, wraps, flexboxInterpolations, flexboxStyles };
